module.exports = __webpack_public_path__ + "img/gofo-icon.7455f25c.svg";